import { globals, view } from '@yola/ws-sdk';
import isBusinessLogo from './is-business-logo';

const isDuplicatedGlobal = (element) => {
  const globalElement = element.closest(globals.constants.GLOBAL_TAG_NAME);
  const source = globalElement?.getAttribute('src');
  if (!source) return false;

  const liveDocument = view.accessors.getLiveDocument();
  if (!liveDocument) return false;

  const sameGlobals = [...liveDocument.querySelectorAll(globals.constants.GLOBAL_TAG_NAME)].filter(
    (node) => node.getAttribute('src') === source
  );

  return sameGlobals.length > 1;
};

// A duplicated business logo reloads the view after resize. The reloaded document does not
// have the drag inline styles, so removing them on the still-visible node only flashes
// the previous size.
const shouldKeepInlineStylesUntilViewReload = (element) =>
  isBusinessLogo(element) && isDuplicatedGlobal(element);

export default shouldKeepInlineStylesUntilViewReload;
